import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { NotificationBell } from "./notification-bell";
import { ThemeToggle } from "@/components/theme-toggle";

interface UnifiedHeaderProps {
  className?: string;
}

export const UnifiedHeader: React.FC<UnifiedHeaderProps> = ({
  className = ""
}) => {
  const navigate = useNavigate();
  const canGoBack = typeof window !== "undefined" && window.history.length > 1;

  return (
    <header
      className={`sticky top-[var(--browser-compat-banner-height,0px)] z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 ${className}`}
    >
      <div className="flex h-14 items-center px-4 w-full">
        <div className="flex items-center space-x-3">
          <SidebarTrigger className="" />
          <Button
            variant="ghost"
            size="sm"
            onClick={() => (canGoBack ? navigate(-1) : navigate("/dashboard"))}
            className="text-xs px-2"
            title="Volver atrás"
            disabled={!canGoBack}
          >
            <ArrowLeft className="h-4 w-4 sm:mr-1" />
            <span className="hidden sm:inline">Volver</span>
          </Button>
        </div>

        <div className="flex flex-1 items-center justify-end space-x-2">
          <ThemeToggle />
          <NotificationBell />
        </div>
      </div>
    </header>
  );
};
